import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Title = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 180%;
    margin-bottom: 32px;
    text-align: center;
    color: ${theme.colors.secondary};
  `}
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Actions = styled(Box)`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
`

export const History = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
`

export const HistoryTitle = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.secondary};
  `}
`

export const FullText = styled.div`
  white-space: normal;
  word-break: break-word;
`
